import { Box, Grid } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { LoadingButton } from "@mui/lab";
import FormikControl from "../../../components/common/FormikControl";
import { useDispatch, useSelector } from "react-redux";
import { addCountry, updateCountry } from "../../../slices/country";

const validationSchema = Yup.object().shape({
    name: Yup.string()
        .min(3, "Country Name must be at least 3 characters")
        .max(50, "Country Name must not exceed 50 characters")
        .matches(/^[a-zA-Z]+([a-zA-Z\s]*[a-zA-Z]+)?$/, "Country Name can only contain letters")
        .required("Country Name is required"),
    country_code: Yup.string()
        .min(3, "Country Code must be at least 3 characters")
        .max(20, "Country Code must not exceed 20 characters")
        .matches(/^[a-zA-Z]+$/, "Country Code can only contain letters")
        .required("Country Code is required"),
});
const AddCountryForm = ({ editData = null,onSuccess }) => {
    const dispatch = useDispatch()
    const { isLoading } = useSelector((state) => state.bmrCountry);
    const initialValues = {
        name: editData?.name ?? "",
        country_code: editData?.country_code ?? "",
    };

    const handleSubmit = async (values) => {
    const payload = {
        name: values.name,
        country_code: values.country_code,
    };

    if (editData) {
        await dispatch(updateCountry({ data: payload, editId: editData.id }));
    } else {
        await dispatch(addCountry(payload));
    }
    if (onSuccess) onSuccess(); 
};
    const handleCountryCodeChange = (e) => {
        formik.setFieldValue("country_code", e.target.value.toUpperCase());
    };
    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: handleSubmit,
        enableReinitialize: true
    })


    const formOptions = [
        {
            label: 'Country Name',
            type: 'text',
            name: 'name',
            required: true,
            placeholder: "Enter Country",
        },
        {
            label: 'Country Code',
            type: 'text',
            name: 'country_code',
            required: true,
            placeholder: 'Enter Country Code ',
            onChange: handleCountryCodeChange 
        },

    ];

    return (
        <Box>
            <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={2} className="mb-3">
                    {formOptions.map((props, key) => (
                        <Grid key={key} item xs={12}>
                            <FormikControl formik={formik} {...props} />
                        </Grid>
                    ))}
                </Grid>
                <Grid container spacing={2} className="mt-3">
                    <Grid item xs={12}>
                        <LoadingButton
                            loading={isLoading}
                            fullWidth type="submit" variant="contained">{editData ? "Update" : "Submit"}</LoadingButton>
                    </Grid>
                </Grid>
            </form>
        </Box>
    );
}

export default AddCountryForm;